<template>
  <div class="home-page">
    <NavBar />

    <div class="home-content">
      <div
        class="banner-wrap"
        v-if="!threedData.embedded_link && !threedData.isLive"
      >
        <b-carousel
          id="carousel-1"
          :interval="6000"
          controls
          fade
          class="home-carousel"
        >
          <b-carousel-slide
            img-src="/images/footballMaungBanner.webp"
            img-width="100%"
          ></b-carousel-slide>
          <b-carousel-slide
            img-src="/images/2d3dBanner.webp"
            img-width="100%"
          ></b-carousel-slide>
        </b-carousel>
      </div>

      <div
        class="notice-wrap"
        v-if="!threedData.embedded_link && !threedData.isLive"
      >
        <NoticeBar
          class="home-notice"
          scrollable
          :text="websiteInfo[0]?.noticeText"
        />
      </div>

      <section class="wallet-card">
        <div class="wallet-top">
          <div class="wallet-user">
            <div class="avatar">
              {{ userInitial }}
            </div>
            <div class="wallet-meta">
              <span class="wallet-label">{{
                $store.state.language === "en" ? "Welcome back" : "ကြိုဆိုပါတယ်"
              }}</span>
              <strong class="wallet-name">{{
                $store.state.authUser.phone || $store.state.authUser.name
              }}</strong>
            </div>
          </div>
          <button
            class="logout-chip"
            type="button"
            @click="onLogoutClick"
            :disabled="isLoggingOut"
          >
            <Loading v-if="isLoggingOut" size="16" color="#e7b534" />
            <span v-else>{{ $t("setting.logout") }}</span>
          </button>
        </div>

        <div class="wallet-balance">
          <span class="wallet-label">{{
            $store.state.language === "en" ? "Balance" : "လက်ကျန်ငွေ"
          }}</span>
          <div class="balance-row">
            <b>{{ Number($store.state.amount).toLocaleString() }}</b>
            <span class="unit">Unit</span>
          </div>
        </div>

        <div class="quick-actions">
          <button
            class="action-btn deposit"
            type="button"
            @click="goQuick('deposit')"
          >
            {{ $t("footer.deposit") }}
          </button>
          <button
            class="action-btn withdraw"
            type="button"
            @click="goQuick('withdraw')"
          >
            {{ $t("footer.withdraw") }}
          </button>
        </div>
      </section>

      <section class="menu-section">
        <h3 class="section-title">
          {{ $store.state.language === "en" ? "Services" : "ဝန်ဆောင်မှုများ" }}
        </h3>
        <div class="menu-grid">
          <button
            v-for="item in menuItems"
            :key="item.path"
            class="menu-card"
            type="button"
            @click="onMenuClick(item.path)"
          >
            <span class="menu-icon">
              <img :src="item.icon" :alt="item.title" />
            </span>
            <span class="menu-title">{{ item.title }}</span>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { NoticeBar, Dialog, Toast, Loading } from "vant";
import { mapActions } from "vuex";

export default {
  components: { NoticeBar, Loading },
  data() {
    return {
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {},
      isLoggingOut: false,
    };
  },
  computed: {
    userInitial() {
      const label =
        this.$store.state.authUser.phone ||
        this.$store.state.authUser.name ||
        "U";
      return String(label).charAt(0).toUpperCase();
    },
    menuItems() {
      return [
        {
          path: "body-fb",
          title: this.$t("football.body"),
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4096.PNG",
        },
        {
          path: "maung-fb",
          title: this.$t("football.mix_parlay"),
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4097%20(1)%20(2).png",
        },
        {
          path: "betslip-history",
          title: this.$t("setting.voucher"),
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4098.PNG",
        },
        {
          path: "live",
          title: "Live",
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4099.PNG",
        },
        {
          path: "finished-matches",
          title: this.$t("match_result"),
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4100.PNG",
        },
        {
          path: "history",
          title: this.$t("setting.transaction"),
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4101.PNG",
        },
        {
          path: "twod-threed",
          title: "2D / 3D",
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/16.png",
        },
        {
          path: "setting",
          title: this.$t("footer.setting"),
          icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/IMG_4102.PNG",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["logoutUser", "fetchUser"]),
    onLogoutClick() {
      this.$playSound();
      this.logout();
    },
    goQuick(path) {
      this.$playSound();
      this.redirectRoute(path);
    },
    onMenuClick(path) {
      this.$playSound();
      this.redirectRoute(path);
    },
    async logout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      try {
        await this.logoutUser();
        Toast.success(
          this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
        );
        this.$router.push("/welcome");
      } catch (error) {
        this.isLoggingOut = false;
      }
    },
    async redirectRoute(path) {
      try {
        if (path === "tip") {
          const text =
            this.$store.state.language === "en"
              ? "This feature is not support yet."
              : "ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။";
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === "en" ? "Okay" : "Okay",
          }).then(() => {
            // on close
          });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format("ll");
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        this.websiteInfo = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/welcome");
    }
    this.fetchWebsiteData();
  },
};
</script>
<style scoped>
.home-page {
  min-height: 100vh;
  padding-bottom: 7rem;
  color: #f5f5f5;
  background: #0c0c0c;
}

.home-content {
  max-width: 720px;
  margin: 0 auto;
  padding: 8px 12px 0;
}

.banner-wrap {
  overflow: hidden;
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
}

.home-carousel {
  width: 100%;
}

.home-carousel >>> .carousel-inner,
.home-carousel >>> .carousel-item,
.home-carousel >>> img {
  border-radius: 14px;
}

.home-carousel >>> .carousel-item {
  height: auto;
}

.home-carousel >>> img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.notice-wrap {
  margin-top: 8px;
}

.home-notice {
  height: 1.9rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #1a1408 !important;
  background: linear-gradient(90deg, #f3d26a, #e7b534) !important;
}

.wallet-card {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 16px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02)),
    #171717;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
}

.wallet-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.wallet-user {
  display: flex;
  align-items: center;
  min-width: 0;
}

.avatar {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1a1408;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
}

.wallet-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.wallet-label {
  font-size: 0.68rem;
  color: #b8b3a8;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

.wallet-name {
  font-size: 0.92rem;
  font-weight: 700;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-chip:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.logout-chip {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  color: #ececec;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}

.wallet-balance {
  margin-top: 8px;
}

.balance-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 0;
  color: #f7d56a;
}

.balance-row b {
  font-size: 1.25rem;
  line-height: 1.1;
  letter-spacing: 0.3px;
}

.unit {
  font-size: 0.82rem;
  color: #d8c48a;
}

.quick-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
}

.action-btn {
  border: 0;
  border-radius: 10px;
  padding: 7px 10px;
  font-weight: 700;
  font-size: 0.82rem;
}

.action-btn.deposit {
  color: #1a1408;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
}

.action-btn.withdraw {
  color: #f7d56a;
  background: #242424;
  border: 1px solid rgba(231, 181, 52, 0.22);
}

.menu-section {
  margin-top: 12px;
}

.section-title {
  margin: 0 4px 8px;
  font-size: 0.88rem;
  font-weight: 700;
  color: #f0e6c8;
}

.menu-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.menu-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 78px;
  padding: 8px 8px 6px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #1c1c1c;
  color: #fff;
  transition: transform 0.15s ease, background 0.15s ease;
}

.menu-card:active {
  transform: scale(0.97);
  background: #1a1a1a;
}

.menu-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(231, 181, 52, 0.08);
}

.menu-icon img {
  width: auto;
  height: 24px;
}

.menu-title {
  margin-top: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
}

</style>
